import Api from './api'
import ApiTest from './api_test'


export const tourLogin = (payload) =>
{

    let {name, password} = payload;
    
    var data = { 
        username: name,
        password: password
    }

    console.log(data)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`https://app-maquetas.herokuapp.com/api/authenticate`, requestOptions);
    /*return Api().post('/api/authenticate', JSON.stringify(data), {
        headers: {
            "Content-Type": 'application/json',
            "x-api-key": "1Nt3r4ct1v3",
        }
    })*/
}

export const getBase64 = () =>
    {

        return Api().get('base64', {
            headers: {
                "Content-Type": "application/json"
            }
        })

    }
    
export async function  getProyecto()
    {
        var idProyecto = '614c8de641a75f0018fb7a04';
        //var idProyecto = '610dab07df05250017a71a1e';

        return Api().get('/api/proyectos/get/'+idProyecto, {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "1Nt3r4ct1v3",
            }
        })
    }


export async function  getProyectos() 
{


    return Api().get('/api/proyectos/get/', {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}

export async function  getDropboxFiles()
{
    var data = { path: "/Constructoras/Bienes & Bienes/Distrito Plaza/" }
    //var data = { path: "/Constructoras/Lar Poyectos/Hacienda San José" }

    return Api().post('/api/dropbox/file-list', data, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}


export const createEmail = (payload) =>
{

    let {name, email, phone, tiposAptosCotizados, aptosCotizados, proyecto } = payload;
    
    var data = { 
        Nombre: name,
        Email: email,
        Telefono: phone,
        // File: 
        //  { value: 'fs.createReadStream("samplePlano.jpg")',
        //    options: { filename: 'samplePlano.jpg', contentType: null } },

        //ContentArray: '{"Aptos":[{"Nombre":"A1-1","Areas":["34.5","38.8"]},{"Nombre":"C1-1","Areas":["54.5","59.5"]}]}',
        //Convert To Json 
        ContentArray: `{"Aptos": ${JSON.stringify(aptosCotizados)}}`,
        Constructora: proyecto.Constructora,
        Proyecto: proyecto.Nombre,
        idProyecto: proyecto._id,
        EmailConstructora: proyecto.Email,
    
    }
    
    //si esta pasando por acá?
    return Api().post('/api/cotizaciones/createEmail', data, {
        headers: {
            "Content-Type": 'application/json',
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}

export const insertCotizacion = (payload) =>
{

    //var idPrimeraEste = "5f610c3e525a671c1099c708" //bd real y test
    let {name, email, phone, aptosCotizados, proyecto } = payload;
    let numerosAptos = [];

    aptosCotizados.forEach(element => {
        numerosAptos.push(element.Numero);
    });


    var data = { 
        Nombre: name,
        Email: email,
        Telefono: phone,
       
        Aptos: JSON.stringify(numerosAptos), //JSON.stringify(aptosCotizados),
        // Constructora: 'IC Constructora',
        Proyecto: proyecto.Nombre,
        idProyecto: proyecto._id,
        // EmailConstructora: 'ui.dmayorga@gmail.com',
    
    }
    
    //si esta pasando por acá?
    return Api().put(`/api/cotizaciones/update/${data.idProyecto}`, data, {
        headers: {
            "Content-Type": 'application/json',
            "x-api-key": "1Nt3r4ct1v3",
        }
    })
}


